import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Home, Building2, Sparkles, Heart, User } from 'lucide-react';

const TABS = [
  { path: '/dashboard', label: 'Home', icon: Home },
  { path: '/properties', label: 'Discover', icon: Building2 },
  { path: '/concierge', label: 'AI Match', icon: Sparkles },
  { path: '/wishlist', label: 'Saved', icon: Heart },
  { path: '/account', label: 'Profile', icon: User },
];

const MobileBottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Only show for logged-in users, not on landing/login/signup/onboarding/admin/partner pages
  const hidePaths = ['/', '/login', '/signup', '/terms', '/privacy', '/partner', '/admin'];
  const isHidden = !user ||
    hidePaths.some(p => location.pathname === p) ||
    location.pathname.startsWith('/partner') ||
    location.pathname.startsWith('/admin') ||
    location.pathname.includes('/onboarding') ||
    // Country-prefixed public routes
    /^\/(uae|in)$/.test(location.pathname);

  if (isHidden) return null;

  // Strip country prefix for matching
  const cleanPath = location.pathname.replace(/^\/(uae|in)\//, '/');

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-white/[0.06]" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around px-1 py-1 pb-[max(0.25rem,env(safe-area-inset-bottom))]">
        {TABS.map(tab => {
          const isActive = cleanPath === tab.path || cleanPath.startsWith(tab.path + '/');
          const Icon = tab.icon;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex flex-col items-center justify-center gap-0.5 py-1.5 px-3 min-w-[56px] rounded-xl transition-all duration-200 ${
                isActive
                  ? 'text-[#C6A15B]'
                  : 'text-white/30 active:text-white/50'
              }`}
              data-testid={`bottom-nav-${tab.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              <div className={`relative ${isActive ? '' : ''}`}>
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.2 : 1.5} />
                {isActive && (
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#C6A15B]" />
                )}
              </div>
              <span className={`text-[10px] font-medium leading-none mt-0.5 ${isActive ? 'text-[#C6A15B]' : ''}`}>
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
